// extracted by mini-css-extract-plugin
export default {"base":"FluMap_base__-DFXU","map":"FluMap_map__vL3lP","mapLegend":"FluMap_mapLegend__Sd3Vz"};